var _circle, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#26C9B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0195 23.2642V15.9755C16.0195 15.6886 16.1056 15.4088 16.2634 15.1721L18.2219 12.2595C18.5304 11.7932 19.298 11.4632 19.9508 11.7071C20.6539 11.9438 21.1202 12.7329 20.9695 13.436L20.5965 15.7819C20.5678 15.9971 20.6252 16.1908 20.7471 16.3414C20.8691 16.4777 21.0484 16.5638 21.2421 16.5638H24.1906C24.7574 16.5638 25.2452 16.7934 25.5321 17.1951C25.8047 17.5825 25.855 18.0847 25.6756 18.594L23.9108 23.9673C23.6884 24.8569 22.72 25.5814 21.7587 25.5814H18.9608C18.4802 25.5814 17.8058 25.4164 17.4974 25.1079L16.5791 24.3977C16.2276 24.1323 16.0195 23.709 16.0195 23.2642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7384 14.5762H12.9995C11.8875 14.5762 11.4355 15.0066 11.4355 16.0683V23.2853C11.4355 24.347 11.8875 24.7775 12.9995 24.7775H13.7384C14.8503 24.7775 15.3023 24.347 15.3023 23.2853V16.0683C15.3023 15.0066 14.8503 14.5762 13.7384 14.5762Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8027 24.047V16.7583C16.8027 16.4713 16.8888 16.1915 17.0466 15.9548L19.0051 13.0422C19.3136 12.5759 20.0812 12.2459 20.734 12.4898C21.4371 12.7265 21.9034 13.5157 21.7527 14.2187L21.3797 16.5646C21.351 16.7798 21.4084 16.9735 21.5303 17.1241C21.6523 17.2604 21.8316 17.3465 22.0253 17.3465H24.9738C25.5406 17.3465 26.0284 17.5761 26.3153 17.9778C26.5879 18.3652 26.6382 18.8674 26.4588 19.3767L24.694 24.75C24.4716 25.6396 23.5032 26.3641 22.5419 26.3641H19.744C19.2634 26.3641 18.589 26.1991 18.2806 25.8907L17.3623 25.1804C17.0108 24.915 16.8027 24.4917 16.8027 24.047Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5216 15.3589H13.7827C12.6707 15.3589 12.2188 15.7893 12.2188 16.8511V24.068C12.2188 25.1298 12.6707 25.5602 13.7827 25.5602H14.5216C15.6335 25.5602 16.0855 25.1298 16.0855 24.068V16.8511C16.0855 15.7893 15.6335 15.3589 14.5216 15.3589Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.8abc58af84a71f8fef3a68fcb11250aa.svg";
export { ForwardRef as ReactComponent };